import React, { useEffect } from 'react';
import { useFilter } from './InvoiceFilterContext';
import { useOrdersFilter } from './OrdersFilterContext';
import { useQuotesFilter } from './QuotesFilterContext';

export function FiltersHydrator({ snapshot }) {
    const { updateFilter: setInvoice, clearFilters: clearInvoice } = useFilter();
    const { updateFilter: setOrders, clearFilters: clearOrders } = useOrdersFilter();
    const { updateFilter: setQuotes, clearFilters: clearQuotes } = useQuotesFilter();

    useEffect(() => {
        if (!snapshot || typeof snapshot !== 'object') {
            return;
        }
         clearInvoice(); clearOrders(); clearQuotes();

        // Hydrate invoice
        if (snapshot.invoice && typeof snapshot.invoice === 'object') {
            Object.entries(snapshot.invoice).forEach(([key, value]) => {
                setInvoice(key, value);
            });
        }

        // Hydrate orders
        if (snapshot.orders && typeof snapshot.orders === 'object') {
            Object.entries(snapshot.orders).forEach(([key, value]) => {
                setOrders(key, value);
            });
        }

        // Hydrate quotes
        if (snapshot.quotes && typeof snapshot.quotes === 'object') {
            Object.entries(snapshot.quotes).forEach(([key, value]) => {
                setQuotes(key, value);
            });
        }
    }, [snapshot]);

    return null;
}
